// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from 'react';
import { classNames } from '@plasmicapp/react-web';

export type LineIconProps = React.ComponentProps<'svg'> & {
  title?: string;
};

export function LineIcon(props: LineIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={'http://www.w3.org/2000/svg'}
      fill={'none'}
      viewBox={'0 0 450 1'}
      height={'1em'}
      width={'1em'}
      style={{
        stroke: 'currentcolor',

        ...(style || {}),
      }}
      className={classNames('plasmic-default__svg', className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path stroke={'currentColor'} strokeWidth={'.15'} d={'M0 .925h450'}></path>
    </svg>
  );
}

export default LineIcon;
/* prettier-ignore-end */
